module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_18-22c62a0afd66f3aea57b8e1906a6629c.jpg";